module.exports = __webpack_public_path__ + "Server-Unhealthy.AzureWebApp.aa540d1124b3b51f196bcea686e628c5.hashedasset.svg";